import { render } from "./Validators.vue?vue&type=template&id=b56a10fa&scoped=true"
import script from "./Validators.vue?vue&type=script&lang=js"
export * from "./Validators.vue?vue&type=script&lang=js"

import "./Validators.vue?vue&type=style&index=0&id=b56a10fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56a10fa"]])

export default __exports__